import { createSlice } from "@reduxjs/toolkit";
import {
  addScolarshipSchool,
  addScolarshipUniversity,
  getAllSchoolScholarship,
  getAllUniversitiesScholarship,
  getUniversities,
  getAlluniversityApplications,
  addUniversityApplication,
  AddDroppedOutRequest,
  getDroppedOutRequests,
  getClub,
} from "../actions/scholarship.actions";

const initialState = {
  TotalUniversityApplications: 0 as number,
  TotalSchoolScholars: 0 as number,
  TotalUniversityScholars: 0 as number,
  droppedOutRequests: [] as any,
  universities: [] as any,
  universityApplications: {
    loading: false,
    error: null as unknown | null,
    data: [] as any,
  },
  addRequestUniversity: {
    loading: false,
    error: null as unknown | null,
    data: {} as any,
  },

  dropOutRequest: {
    loading: false,
    error: null as unknown | null,
    data: {} as any,
  },
  addUniversityApplication: {
    loading: false,
    error: null as unknown | null,
    data: {} as any,
  },
  addRequestSchool: {
    loading: false,
    error: null as unknown | null,
    data: {} as any,
  },
  scholarshipsUniversity: {
    loading: false,
    error: null as unknown | null,
    data: [] as any,
  },
  scholarshipsSchool: {
    loading: false,
    error: null as unknown | null,
    data: [] as any,
  },
  club: [] as any,
  TotalDropouts: 0 as number,
  loading: false,
  error: null as unknown | null,
};

export const scholarshipsSlice = createSlice({
  name: "scholarship",
  initialState: initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getUniversities.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getUniversities.fulfilled, (state, action) => {
      state.universities = action.payload;
      state.loading = false;
    });
    builder.addCase(getUniversities.rejected, (state, action) => {
      state.universities = [];
      state.loading = false;
      state.error = action.payload;
    });

    builder.addCase(addScolarshipUniversity.pending, (state) => {
      state.addRequestUniversity.loading = true;
    });
    builder.addCase(addScolarshipUniversity.fulfilled, (state, action) => {
      state.addRequestUniversity.data = action.payload;
      state.addRequestUniversity.loading = false;
    });
    builder.addCase(addScolarshipUniversity.rejected, (state, action) => {
      state.addRequestUniversity.data = {};
      state.addRequestUniversity.loading = false;
      state.error = action.payload;
    });

    builder.addCase(getAllUniversitiesScholarship.pending, (state) => {
      state.scholarshipsUniversity.loading = true;
    });
    builder.addCase(
      getAllUniversitiesScholarship.fulfilled,
      (state, action) => {
        state.scholarshipsUniversity.data = action.payload.data;
        state.TotalUniversityScholars = action.payload.total_pages;
        state.scholarshipsUniversity.loading = false;
      }
    );
    builder.addCase(getAllUniversitiesScholarship.rejected, (state, action) => {
      state.TotalUniversityScholars = 0;
      state.scholarshipsUniversity.data = [];
      state.scholarshipsUniversity.loading = false;
      state.error = action.payload;
    });

    builder.addCase(getAllSchoolScholarship.pending, (state) => {
      state.scholarshipsSchool.loading = true;
    });
    builder.addCase(getAllSchoolScholarship.fulfilled, (state, action) => {
      state.scholarshipsSchool.data = action.payload.data;
      state.TotalSchoolScholars = action.payload.total_pages;
      state.scholarshipsSchool.loading = false;
    });
    builder.addCase(getAllSchoolScholarship.rejected, (state, action) => {
      state.TotalSchoolScholars = 0;
      state.scholarshipsSchool.data = [];
      state.scholarshipsSchool.loading = false;
      state.error = action.payload;
    });

    builder.addCase(addScolarshipSchool.pending, (state) => {
      state.addRequestSchool.loading = true;
    });
    builder.addCase(addScolarshipSchool.fulfilled, (state, action) => {
      state.addRequestSchool.data = action.payload;
      state.addRequestSchool.loading = false;
    });
    builder.addCase(addScolarshipSchool.rejected, (state, action) => {
      state.addRequestSchool.data = {};
      state.addRequestSchool.loading = false;
      state.error = action.payload;
    });
    // get all university applications
    builder.addCase(getAlluniversityApplications.pending, (state) => {
      state.universityApplications.loading = true;
    });
    builder.addCase(getAlluniversityApplications.fulfilled, (state, action) => {
      state.universityApplications.data = action.payload.data;
      state.TotalUniversityApplications = action.payload.total_pages;
      state.universityApplications.loading = false;
    });
    builder.addCase(getAlluniversityApplications.rejected, (state, action) => {
      state.universityApplications.data = [];
      state.TotalUniversityApplications = 0;
      state.universityApplications.loading = false;
      state.error = action.payload;
    });
    //add university application
    builder.addCase(addUniversityApplication.pending, (state) => {
      state.addUniversityApplication.loading = true;
    });
    builder.addCase(addUniversityApplication.fulfilled, (state, action) => {
      state.addUniversityApplication.data = action.payload;
      state.addUniversityApplication.loading = false;
    });
    builder.addCase(addUniversityApplication.rejected, (state, action) => {
      state.addUniversityApplication.data = {};
      state.addUniversityApplication.loading = false;
      state.error = action.payload;
    });
    builder.addCase(getDroppedOutRequests.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getDroppedOutRequests.fulfilled, (state, action) => {
      state.droppedOutRequests = action.payload.data;
      state.TotalDropouts = action.payload.total_pages;
      state.loading = false;
    });
    builder.addCase(getDroppedOutRequests.rejected, (state, action) => {
      state.TotalDropouts = 0;

      state.droppedOutRequests = [];
      state.loading = false;
      state.error = action.payload;
    });
    //
    builder.addCase(AddDroppedOutRequest.pending, (state) => {
      state.dropOutRequest.loading = true;
    });
    builder.addCase(AddDroppedOutRequest.fulfilled, (state, action) => {
      state.dropOutRequest.data = action.payload;
      state.dropOutRequest.loading = false;
    });
    builder.addCase(AddDroppedOutRequest.rejected, (state, action) => {
      state.dropOutRequest.data = [];
      state.dropOutRequest.loading = false;
      state.error = action.payload;
    });
    // get CLUB
    builder.addCase(getClub.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getClub.fulfilled, (state, action) => {
      state.club = action.payload;
      state.loading = false;
    });
    builder.addCase(getClub.rejected, (state, action) => {
      state.club = [];
      state.loading = false;
      state.error = action.payload;
    });
  },
});

export default scholarshipsSlice.reducer;
